import React from "react";
import { SortItem } from "@/apiUtils/algoliaUtils/types";

export interface IProps {
  selected?: string;
  sortOptions: SortItem[];
  onChange: (key: string, value: string) => void;
  onClose?: () => void;
}

const SortList = ({ selected = "", sortOptions, onChange, onClose }: IProps) => {
  const handleSort = (option: SortItem) => {
    onChange("sort", option?.value || "");
    onClose?.();
  };

  return (
    <>
      {sortOptions?.map((option, index) => (
        <React.Fragment key={index}>
          <div
            onClick={() => handleSort(option)}
            className={`cursor-pointer p-4 ${selected === option?.value || selected === option?.type ? "bg-primary-1 text-white" : ""}`}
          >
            <p className="text-sm">{option?.label}</p>
          </div>
          <div className="mx-4 h-[1px] bg-tertiary-7" />
        </React.Fragment>
      ))}
    </>
  );
};

export default SortList;
